import { AppConfig } from '@joehua/cms-components'
import React from 'react'
import dlv from 'dlv'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { themr } from 'react-css-themr'

export interface PhoneMeTheme {
  root?: string
  link?: string
  phone?: string
}

export const defaultPhoneMeTheme: PhoneMeTheme = {
  root: 'pv1 flex items-center bg-rc br-pill ph3',
  link: 'link dim',
  phone: 'white fw7 f5 ph2',
}

function DumpPhoneMe({
  size = '1x',
  color = '#fff',
  theme = {},
}: {
  size?: any
  color?: string
  theme?: PhoneMeTheme
}) {
  return (
    <AppConfig>
      {({ data }) => {
        const contact = dlv(data, 'contact', {})
        return (
          <div className={theme.root}>
            <FontAwesomeIcon icon="phone-volume" color={color} size={size} />{' '}
            <a href={`tel:${contact.phone}`} className={theme.link}>
              <span className={theme.phone}>{contact.phone}</span>
            </a>
          </div>
        )
      }}
    </AppConfig>
  )
}

const PhoneMe = themr(
  'PhoneMe',
  {},
  {
    composeTheme: 'softly',
  },
)(DumpPhoneMe)

export default PhoneMe
